import { render, staticRenderFns } from "./ProductRight.vue?vue&type=template&id=05b5b0f8&scoped=true&"
import script from "./ProductRight.vue?vue&type=script&lang=js&"
export * from "./ProductRight.vue?vue&type=script&lang=js&"
import style0 from "./ProductRight.vue?vue&type=style&index=0&id=05b5b0f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b5b0f8",
  null
  
)

export default component.exports